<template>
  <footer :class="isPath?'homeFooter':''">
    <div class="authorize full_layout" v-if="isPath">
      <h3 class="allTitle">{{$t('Authorized')}}</h3>
      <img class="authorizeDiv" src="../../static/images/footer_empower.png">
      <!-- <div class="authorizeDiv"></div> -->
      <!-- <ul class="authorizeList">
        <li v-for="(item, index) in authorize" :key='index'><img :src="item" /></li>
      </ul> -->
    </div>
   <!--  daka备案/许可证编号为：沪ICP备2022031093号 -->
    <div class="copytext">
      Daka Hongkong Culture Development Limited &copy; Daka 2012-{{ year }} 
      <div>
        <router-link :to="{path:'/privacyagreement'}">{{$t('PrivacyPolicy')}}</router-link> | 
        <router-link :to="{path:'/useragreement'}">{{$t('UserAgreement')}}</router-link> | 
        <span>ICP证：沪ICP备2022031093号-1</span>
        <!-- <span>增值电信业务经营许可证：沪ICP备2022031093号-1</span> -->
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'bottomFooter',
  components: {  },
  data() {
    return {
      year:2023,
      authorize:this.$enumInfo.authorize
    }
  },
  props: {
    isPath: Boolean,
  },
  mounted() {
    var date=new Date();
    var year=date.getFullYear();
    this.year=year;
  },
  created() {
  },
  methods: {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/footer.css";

</style>



// WEBPACK FOOTER //
// src/components/footer.vue